/* eslint-disable indent */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';

import { COLORS } from '../../../theme';
import { ALIGNMENT, SIZES } from './constants';

export const Container = styled(Box)`
  display: flex;
  flex-direction: row;
  padding: ${({ $size, theme }) =>
    $size === SIZES.SMALL
      ? theme.spacing.m2
      : `${theme.spacing.l1} ${theme.spacing.l2}`};
  background-color: rgba(255, 255, 255, 0.01);
  background-image: ${({ $showBackground }) =>
    $showBackground === false
      ? 'none'
      : "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%'><rect x='0' y='0' width='100%' height='100%' rx='12' ry='12' fill='none' stroke='%23CECFD2' stroke-width='2' stroke-dasharray='5' /></svg>\")"};
  border-radius: ${({ theme }) => theme.borderRadius.primary};
  justify-content: ${({ image }) => (image ? 'space-between' : 'center')};
  align-items: center;

  ${({ $align }) =>
    $align === ALIGNMENT.CENTER &&
    `
    align-items: center;
    text-align: center;
  `}

  ${({ $align }) =>
    $align === ALIGNMENT.LEFT &&
    `
    justify-content: left;
  `}
`;

export const Title = styled(Typography)`
  && {
    margin-bottom: ${({ theme }) => theme.spacing.s2};
  }
`;

export const Content = styled.div`
  margin-top: ${({ $align, theme }) =>
    $align === ALIGNMENT.CENTER ? theme.spacing.m2 : theme.spacing.m4};
`;

export const Description = styled(Typography)`
  && {
    margin-top: ${({ theme }) => theme.spacing.s2};
    color: ${COLORS.black50};
  }
`;

export const IconContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s2};

  svg {
    font-size: 36px;

    path {
      fill: ${COLORS.black40};
    }
  }
`;
